export default "__VITE_ASSET__MqEYXG70__"